export const appConfig = {
  name: "SEO AI Pal",
  author: "Matteo Ricupero",
  domainName: "seoaipal.com",
  analyticsWebsiteId: "5248dcb2-3e1f-4bea-aad4-49ed9bf2f5eb",
  appStoreUrl: null,
  playStoreUrl: null,
};
